import React from 'react';
export const QuotationMarkSVG = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={11}
    fill="none"
    {...props}
  >
    <path
      fill="#4964E9"
      d="M.143 10.01V7.22c0-.838.155-1.703.467-2.593.325-.904.765-1.755 1.32-2.554A9.997 9.997 0 0 1 3.78.01l2.58 1.493c-.515.812-.949 1.67-1.3 2.574-.353.903-.529 1.945-.529 3.123v2.81H.143Zm6.784 0V7.22c0-.838.156-1.703.467-2.593.325-.904.765-1.755 1.32-2.554A9.997 9.997 0 0 1 10.563.01l2.58 1.493c-.515.812-.948 1.67-1.3 2.574-.352.903-.528 1.945-.528 3.123v2.81H6.927Z"
    />
  </svg>
);
